import React, { useState } from 'react';
import './SliderPlaying.scss';
import Slider from 'react-rangeslider';
import { FORMAT_TIME } from '../../../constants/format';
import { useDataLayerValue } from '../../../DataLayer';

function SliderPlaying(props) {
    const [{ time_playing }, dispatch] = useDataLayerValue();
    const [playedUpdate, setPlayedUpdate] = useState({});
    const [isOnChangeSlider, setIsOnChangeSlider] = useState(false);
    const handleChangeReverse = (value) => {
        setIsOnChangeSlider(true);
        setPlayedUpdate({ ...time_playing, playedSeconds: ((props.totalTime / 1000) * value), played: value });
    }
    const handleOnChangeComplete = (value) => {
        if (playedUpdate.playedSeconds >= 0) {
            // dispatch({
            //     type: 'SET_PLAYING_LOADING',
            //     playing_loading: true
            // });
            dispatch({
                type: 'SET_TIME_PLAYING',
                time_playing: playedUpdate
            });
            dispatch({
                type: 'SET_SEEK_TO',
                seek_to: true
            });
        }
        setIsOnChangeSlider(false);
    }

    return (
        <div className={`playback-bar ${props.isMobile ? 'is-mobile' : ''}`}>
            {!props.isMobile && <div className="playback-bar__progress-time" as="div">{FORMAT_TIME(isOnChangeSlider ? (playedUpdate.playedSeconds ? playedUpdate.playedSeconds : 0) : (time_playing.playedSeconds ? time_playing.playedSeconds : 0))}</div>}
            <div className="progress-bar">
                <div className='slider-horizontal'>
                    <Slider
                        min={0}
                        max={1000}
                        value={isOnChangeSlider ? playedUpdate.played : time_playing.played}
                        orientation='horizontal'
                        onChange={handleChangeReverse}
                        onChangeComplete={handleOnChangeComplete}
                    />
                </div>
            </div>
            {!props.isMobile && <div className="playback-bar__progress-time" as="div">{FORMAT_TIME(props.totalTime)}</div>}
            {props.isMobileShowTime && <div className="playback-bar__progress-time-mobile">
                <div className="playback-bar__progress-time" as="div">{FORMAT_TIME(isOnChangeSlider ? (playedUpdate.playedSeconds ? playedUpdate.playedSeconds : 0) : (time_playing.playedSeconds ? time_playing.playedSeconds : 0))}</div>
                <div className="playback-bar__progress-time" as="div">{FORMAT_TIME(props.totalTime)}</div>
            </div>}
        </div>


    );
}

export default SliderPlaying;